// Frame shape registry. Paths are normalized to a 0..1 box. The canvas
// renderer, thumbnails, and panel previews all scale them: <clipPath><path
// d={path} transform={`scale(${w} ${h})`} /></clipPath>. userSpaceOnUse
// units (the default) keep the defs compatible with utils/exportClipPath.js,
// which parses the transform attribute when baking export canvases.
export const FRAME_SHAPES = [
  { id: 'rectangle', name: 'Rectangle', path: 'M0,0 H1 V1 H0 Z' },
  {
    id: 'rounded', name: 'Rounded',
    path: 'M0.1,0 H0.9 Q1,0 1,0.1 V0.9 Q1,1 0.9,1 H0.1 Q0,1 0,0.9 V0.1 Q0,0 0.1,0 Z',
  },
  { id: 'circle', name: 'Circle', path: 'M0.5,0 A0.5,0.5 0 1 1 0.5,1 A0.5,0.5 0 1 1 0.5,0 Z' },
  { id: 'triangle', name: 'Triangle', path: 'M0.5,0 L1,1 L0,1 Z' },
  { id: 'pentagon', name: 'Pentagon', path: 'M0.5,0 L1,0.38 L0.81,1 L0.19,1 L0,0.38 Z' },
  { id: 'hexagon', name: 'Hexagon', path: 'M0.25,0 L0.75,0 L1,0.5 L0.75,1 L0.25,1 L0,0.5 Z' },
  {
    id: 'heart', name: 'Heart',
    path: 'M0.5,1 C0.2,0.78 0,0.6 0,0.32 A0.26,0.26 0 0 1 0.5,0.22 A0.26,0.26 0 0 1 1,0.32 C1,0.6 0.8,0.78 0.5,1 Z',
  },
  { id: 'arch', name: 'Arch', path: 'M0,0.5 A0.5,0.5 0 0 1 1,0.5 V1 H0 Z' },
];

export const getFrameShape = (id) =>
  FRAME_SHAPES.find((s) => s.id === id) || FRAME_SHAPES[0];
